import { SpotPreview } from "fleet/view/strategy-v2/spot-preview";
import React from "react";

function formatTags(TagElement, tag) {
  if (!tag) {
    return null;
  }

  if (Array.isArray(tag)) {
    return tag.map((t) => React.cloneElement(TagElement, { children: t }));
  }

  return React.cloneElement(TagElement, { children: tag });
}

function formatSpotPreview(_, spot) {
  if (!spot) {
    return null;
  }

  const { mimeType, numberOfSpots, type, url, available } = spot;

  if (type === "application" && !available) {
    return null;
  }

  return (
    <SpotPreview
      mimeType={mimeType}
      numberOfSpots={numberOfSpots}
      type={type}
      url={url}
    />
  );
}

export { formatSpotPreview, formatTags };
